import React from 'react';

export default function Footer() {
  return (
    <footer>
      <small>Copyright © 2020 The Warheads Projects. All rights reserved.</small>
    </footer>
  );
}
